<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure_1" role="doc-chapter">
<div class="epigraph" role="doc-epigraph">
<p class="epf"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span>Teaching is about taking things apart; writing is about putting things together.</p>
<p class="ept">TONI MORRISON, INTERVIEWED BY HILTON ALS IN THE <i>NEW YORKER</i> (2003)</p>
<p class="epf">What’s the story, morning glory?</p>
<p class="ept">“THE TELEPHONE HOUR,” FROM THE MUSICAL <i>BYE BYE BIRDIE</i> (1960) (ALSO THE TITLE OF A 1995 ALBUM BY OASIS)</p>
<p class="epf">You must not take what I say as definite at all ever, but all as by way of example only. The whole thing might perhaps be done in some quite different way, and what I say are only suggestions toward the final effect. The ways and means to it may be different from what I have used to illustrate.</p>
<p class="ept">EDITOR MAX PERKINS, OFFERING WRITING ADVICE TO MARJORIE KINNAN RAWLINGS (WINNER OF THE 1939 PULITZER PRIZE IN LITERATURE FOR HER NOVEL <i>THE YEARLING</i>)</p>
<p class="epf">O rocks! Tell us in plain words.</p>
<p class="ept">MOLLY BLOOM, WANTING CLARIFICATION, IN <i>ULYSSES</i> (1922)</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-germano-0007.vue?3cd54764